import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/AuthProvider";

import { getFirestore, doc, getDoc, collection, getDocs } from "firebase/firestore"
import Topic from "../components/Topic";
import { Link, useNavigate } from "react-router-dom";

import "../styling/Dashboard.css"

const Dashboard = () => {
    const { user, logout } = useContext(AuthContext);
    const db = getFirestore();
    const navigate = useNavigate();

    const [topicsAndSubtopics, setTopicsAndSubtopics] = useState(new Map());
    const [userProgress, setUserProgress] = useState(new Map());

    const handleLogout = async () => {
        await logout();
        navigate("/"); 
    };

    const fetchTopicsAndSubtopics = async() => {
        try {
            const fetchedTopicsAndSubtopics = new Map();

            const topicsRef = collection(db, "topics");
            const fetchedTopics = await getDocs(topicsRef);

            for (const topicDoc of fetchedTopics.docs) {
                const topicData = topicDoc.data();
                const topicName = topicData.name;

                const subtopicIds = topicData.subtopics
                
                let subtopicNames = []

                for (const subtopicId of subtopicIds) {
                    
                    const subtopicRef = doc(db, "subtopics", subtopicId)
                    const fetchedSubtopic = await getDoc(subtopicRef)
                    const fetchedSubtopicName = fetchedSubtopic.data().name

                    subtopicNames.push(fetchedSubtopicName)
                }

                fetchedTopicsAndSubtopics.set(topicName, subtopicNames)
            }
            setTopicsAndSubtopics(fetchedTopicsAndSubtopics)
        } catch(error) {
            console.log("Error: ", error)
        }
    }

    const fetchUserProgress = async() => {
        try {
            const fetchedUserProgress = new Map();

            const userProgressRef = doc(db, "user_progress", user.uid);
            const userProgressSnap = await getDoc(userProgressRef);
            const userProgressData = userProgressSnap.data();

            for (const [topic, object] of Object.entries(userProgressData)) {
                for (const [subtopic, subtopicProgress] of Object.entries(object)) {
                    fetchedUserProgress.set(subtopic, subtopicProgress.amountCompleted)
                }
            }

            fetchedUserProgress.set("questionsCompleted", userProgressData.questionsCompleted)
            fetchedUserProgress.set("questionsCorrect", userProgressData.questionsCorrect)

            setUserProgress(fetchedUserProgress);

        } catch(error) {
            console.log("Error: ", error)
        }
    }

    // Retrieve user progress for each subtopic
    useEffect(() => {
        fetchTopicsAndSubtopics();
        fetchUserProgress();
    }, [])

    return (
        <div>
            <div className="navbar">
                <div className="navbar__left">
                <Link to="/dashboard">Home</Link>
                </div>
                <div className="navbar__right">
                <Link to="/dashboard">Practice</Link>
                <button className="navbar__sign-up-button" onClick={handleLogout}>
                    Sign Out
                </button>
                </div>
            </div>
            <div className="progress-title">
                <h1 className="progress-title__text">Your Progress</h1>
            </div>

            <div className="stats">
                <div className="stats__container">
                    <div className="stats__box">
                        <h2 className="stats__number">{userProgress.get("questionsCompleted") || 0}</h2>
                    </div>
                    <div className="stats__text-container">
                        <p className="stats__text">Questions Answered</p>
                    </div>
                </div>

                <div className="stats__container">
                    <div className="stats__box">
                        <h2 className="stats__number">{userProgress.get("questionsCorrect") || 0}</h2>
                    </div>
                    <div className="stats__text-container">
                        <p className="stats__text">Questions Correct</p>
                    </div>
                </div>

                <div className="stats__container">
                    <div className="stats__box">
                        <h2 className="stats__number">
                        {userProgress.get("questionsCompleted") > 0 
                            ? Math.floor((userProgress.get("questionsCorrect") / userProgress.get("questionsCompleted")) * 100) + "%" 
                            : "0%"}
                        </h2>
                    </div>
                    <div className="stats__text-container">
                        <p className="stats__text">Accuracy</p>
                    </div>
                </div>
            </div>
            
            <div className="topics-container">
                {Array.from(topicsAndSubtopics.entries()).map(([topic, subtopics]) => (
                    <Topic 
                        key={topic}
                        topic={topic}
                        subtopics={subtopics}
                        progress={userProgress}
                    />
                ))}
            </div>
        </div>
    )
}

export default Dashboard;